<ng-container *transloco="let t; read: 'ime.common.specs'">
  <ng-container *ngLet="toggleableColumns | filterBy: ['IsSelected']: true as columns">
    <p-table [(selection)]="selectedSpecs"
             [rowHover]="true" [rowTrackBy]="trackById"
             [scrollable]="true"
             [tableStyle]="{ 'min-width': '50rem' }" [value]="context.Specs | filterAndGroupAndSortSpecs : context : showOwnProperties.IsSelected : showLocalization : (classificatorValuesQuery.propertyGroups$ | async) : (propertiesQuery.selectAll$ | async): toggleableColumns" dataKey="Id" groupRowsBy="RowGroupKey"
             rowGroupMode="subheader"
             scrollHeight="flex" styleClass="p-datatable-xs p-datatable-borderless white-rows p-inner-table-auto white-hoverable-table">
      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="showCheckboxes" style="width: 30px">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th *ngIf="showLocalization || showLocalizationByLine" class="min-wx-128">{{ t('Language') }}</th>
          <th class="min-wx-256" pFrozenColumn>{{ t('Spec') }}</th>
          <th class="min-wx-128">{{ t('Value') }}</th>
          <th style="width: 115px">{{ t('Visibility') }}</th>
          <th *ngFor="let column of columns" class="min-wx-{{column.Width}}">
            {{ column.Name | transloco }}
          </th>
          <th [style]="showLocalizationButton ? {'width': '74px'} : {'width': '37px'}" alignFrozen="right" class="text-end bg-white" pFrozenColumn>
            <div #editDropdown="ngbDropdown" (openChange)="$event === false ? updateSettings() : false" [autoClose]="false" container="body" ngbDropdown>
              <button aria-expanded="false" aria-haspopup="true" class="btn btn-sm btn-outline-primary dropdown-toggle-without-arrow" ngbDropdownToggle role="button" type="button">
                <svg class="icon small" inlineSVG="#bars-3" viewBox="0 0 8 8"></svg>
              </button>
              <div ngbDropdownMenu>
                <app-copy-paste-menu-item (onClipboardPaste)="paste(true); editDropdown.close()" (onCopy)="copyPasteService.copy('Spec', selectedSpecs); editDropdown.close()"
                                          (onPaste)="paste(); editDropdown.close()"
                                          [allowCopyAll]="false"
                                          [readonly]="readonly"></app-copy-paste-menu-item>
                <button (click)="showOwnProperties.IsSelected = !showOwnProperties.IsSelected; shouldSaveSettings = true" [ngClass]="{'active': showOwnProperties.IsSelected}" ngbDropdownItem type="button">
                  {{ t('Hide inherited') }}
                </button>
                <button (click)="removeSelected()" *ngIf="selectedSpecs.length" class="text-danger" ngbDropdownItem type="button">
                  <svg class="icon small" inlineSVG="#trash" viewBox="0 0 8 8"></svg>
                  {{ t('Remove selected') }}
                </button>
                <div class="dropdown-divider"></div>
                <h6 class="dropdown-header">{{ t('Columns') }}</h6>
                <button (click)="showCheckboxes = !showCheckboxes" [ngClass]="{'active': showCheckboxes}" ngbDropdownItem type="button">
                  {{ t('Selection') }}
                </button>
                <ng-container *ngFor="let column of toggleableColumns">_pta
                  <div class="d-flex btn-group btn-group-sm me-1 pe-2">
                    <button (click)="toggleColumn(column); shouldSaveSettings = true" [ngClass]="{'active': column.IsSelected}" class="btn btn-sm btn-outline-primary" ngbDropdownItem type="button">
                      {{ column.Name | transloco }}
                    </button>
                    <div *ngIf="column.Values?.length > 0" [autoClose]="'outside'" aria-label="Button group with nested dropdown" class="btn-group btn-group-sm" ngbDropdown role="group">
                      <button class="btn btn-sm btn-outline-primary dropdown-toggle-split" ngbDropdownToggle type="button"></button>
                      <div class="dropdown-menu" ngbDropdownMenu>
                        <button (click)="toggleColumnValue(val); shouldSaveSettings = true" *ngFor="let val of column.Values" [ngClass]="{'active': val.State}" ngbDropdownItem>{{ val.Text }}</button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template let-line pTemplate="groupheader">
        <tr class="bg-gray-200 rounded-2" pRowGroupHeader>
          <td class="rounded-2 py-0 pe-0 ps-2 bg-transparent" pFrozenColumn>
            <div class="row">
              <div class="col">
                <h5 class="mt-1">{{ line.Group }}</h5>
              </div>
            </div>
          </td>
          <td class="text-end" colspan="100"></td>
          <td alignFrozen="right" class="text-end bg-transparent" pFrozenColumn>
            <div *ngIf="!readonly" class="col text-end">
              <button (click)="addNewSpecLine(line?.RowGroupKey)" class="btn btn-sm btn-outline-primary text-nowrap" id="addToGroup-{{line?.Id}}" type="button">
                <svg class="icon small" inlineSVG="#plus" viewBox="0 0 8 8"></svg>
                {{ t('Add to group') }}
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template let-line let-rowIndex="rowIndex" pTemplate="body">
        @let property = propertiesQuery.selectEntity(line.PropertyId) | async;
        <ng-container *ngLet="columns | find: 'Identifier': columnIdentifiers.Source as hasSourceColumn">
          <tr *ngIf="asLine(line) as line" [ngClass]="{'newline': line.$isNew, 'bg-gray-300': !!line.LanguageId}" class="p-selectable-row">
            <td *ngIf="showCheckboxes">
              <p-tableCheckbox #tableCheckbox (click)="changeSelection(tableCheckbox, $event)" [index]="rowIndex" [value]="line"></p-tableCheckbox>
            </td>
            <td *ngIf="showLocalization || showLocalizationByLine" class="parent" mesStopClickPropagation pEditableColumn>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <ng-select (ngModelChange)="onMappingChanged(line)" [(ngModel)]="line.LanguageId" [items]="languagesQuery.getAll$ | async" [readonly]="readonly" bindLabel="DisplayName"
                             bindValue="Id" class="select-sm form-control" name="LanguageId-{{line.Id}}" virtualScroll="true"></ng-select>
                </ng-template>
                <ng-template pTemplate="output">
                  <ng-container *ngIf="!line.LanguageId && !readonly" [ngTemplateOutletContext]="{columnName: 'ime.common.specs.Language'}" [ngTemplateOutlet]="editIcon"></ng-container>
                  {{ languagesQuery.selectEntity(line.LanguageId) | async | displayName }}
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="bg-white" *ngLet="(context.Specs | isSpecDuplicate: line.PropertyId: line.LanguageId: line.OriginClv) as isDuplicate" [ngClass]="{'bg-warning': isDuplicate}" id="property-{{line.Id}}" mesStopClickPropagation pEditableColumn pFrozenColumn>
              <div *ngIf="isDuplicate" class="text-white text-uppercase">
                <svg [inlineSVG]="'#exclamation-triangle'" class="icon small mb-1" viewBox="0 0 8 8">
                </svg>
                {{ t('Duplicate!') }}
              </div>
              <p-cellEditor *ngIf="!line.$isNew; else selectPropertyTmpl">
                <ng-template pTemplate="input">
                  <ng-template [ngTemplateOutlet]="selectPropertyTmpl"></ng-template>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ property | displayName }}
                </ng-template>
              </p-cellEditor>
              <ng-template #selectPropertyTmpl>
                <mes-web-property-select (entityIdChange)="line.PropertyId = $event; onPropertyChanged(line)"
                                         [appendTo]="'body'"
                                         [clearable]="false"
                                         [entityId]="line.PropertyId"
                                         [initOpened]="true"
                                         [items$]="propertiesQuery.selectAll$"
                                         [propertyGroups]="line.GroupClv && line.$isNew ? [line.GroupClv] : []"
                                         [readonly]="readonly"
                                         name="property-{{line.Id}}"></mes-web-property-select>
              </ng-template>
            </td>
            <td class="parent text-break" mesStopClickPropagation pEditableColumn>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <web-spec-value (changed)="onLineChanged(line)" (edit)="specModelHandlingService.editSpec(context, line)" [initOpened]="true" [isInvalid]="(line | isSpecValueInvalid) && wasValidated" [readonly]="readonly" [spec]="line"></web-spec-value>
                </ng-template>
                <ng-template pTemplate="output">
                  <div [className]="(line | isSpecValueInvalid) && wasValidated ? 'border border-danger' : ''">
                    <ng-container *ngIf="!line.hasValue() && !readonly; else specValueTmpl" [ngTemplateOutletContext]="{columnName: 'ime.common.specs.Value'}" [ngTemplateOutlet]="editIcon"></ng-container>
                    <ng-template #specValueTmpl>
                      <app-spec-value-view (edit)="specModelHandlingService.editSpec(context, line)" [property]="propertiesQuery.selectEntity(line?.PropertyId) | async" [sourceId]="context?.Id" [spec]="line" class="d-flex"></app-spec-value-view>
                    </ng-template>
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="parent" mesStopClickPropagation pEditableColumn>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <ng-select (change)="onMappingChanged(line)" [(ngModel)]="line.MandatoryClv" [class.is-invalid]="(line | isSpecVisibilityInvalid) && wasValidated" [items]="classificatorValuesQuery.mandatories$ | async | orderBy: 'Sequence'"
                             [readonly]="readonly" appendTo="body" bindLabel="DisplayName" bindValue="Id" class="select-sm form-control" id="mandatory-{{line.Id}}" name="mandatory-{{line.Id}}">
                    <ng-template let-item="item" ng-label-tmp>
                      <ng-container [ngTemplateOutletContext]="{clv: item}" [ngTemplateOutlet]="visibilityTmpl"></ng-container>
                    </ng-template>
                  </ng-select>
                </ng-template>
                <ng-template pTemplate="output">
                  <div [className]="(line | isSpecVisibilityInvalid) && wasValidated ? 'border border-danger' : ''">
                    <ng-container *ngIf="!line.MandatoryClv && !readonly" [ngTemplateOutletContext]="{columnName: 'ime.common.specs.Visibility'}" [ngTemplateOutlet]="editIcon"></ng-container>
                    <span *ngIf="classificatorValuesQuery.selectEntity(line.MandatoryClv) | async as visibility" class="ms-1" style="white-space: nowrap">
                    <ng-container [ngTemplateOutletContext]="{clv: visibility}" [ngTemplateOutlet]="visibilityTmpl"></ng-container>
                  </span>
                  </div>
                </ng-template>
              </p-cellEditor>
              <ng-template #visibilityTmpl let-clv="clv">
                <app-spec-line-visibility-display [visibilityClv]="clv.Id"/>
                {{ clv | displayName }}
              </ng-template>
            </td>
            <ng-container *ngFor="let column of columns">
              <td *ngLet="context.Id + '-' + column.Code + '-' + rowIndex as cellId" class="parent" id="{{context.Id}}-{{column.Code}}-{{rowIndex}}" mesStopClickPropagation pEditableColumn>
                <ng-container [ngSwitch]="column.Identifier">
                  <ng-container *ngSwitchCase="columnIdentifiers.Source">
                    <div [title]="(line.LineSource?.Type ?? '') + ': ' + line.LineSource?.Code + ': ' + line.LineSource?.Id" class="text-truncate">
                  <span *ngIf="line.LineSource?.Id" class="badge bg-default">
                    {{ line.LineSource?.Code }}
                  </span>
                    </div>
                    <div [title]="(line.MappingSource?.Type ?? '') + ': ' + line.MappingSource?.Code + ': ' + line.MappingSource?.Id" class="text-truncate mt-1">
                  <span *ngIf="line.MappingSource?.Id" class="badge bg-gray-700">
                    {{ line.MappingSource?.Code }}
                  </span>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="columnIdentifiers.Origin">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <mes-web-classificator-value-select (entityIdChange)="onClvPropertyChanged(line, $event, 'OriginClv')" [entityId]="line.OriginClv" [initOpened]="true"
                                                            [items$]="classificatorValuesQuery.mappingOrigins$" [readonly]="readonly" id="origin-{{line.Id}}" name="origin-{{line.Id}}"/>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container *ngIf="!line.OriginClv && !readonly" [ngTemplateOutletContext]="{columnName: column.Name}" [ngTemplateOutlet]="editIcon"></ng-container>
                        {{ classificatorValuesQuery.selectEntity(line.OriginClv) | async | displayName }}
                      </ng-template>
                    </p-cellEditor>
                  </ng-container>
                  <ng-container *ngSwitchCase="columnIdentifiers.Formula">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <mes-web-expression-formula (changed)="onMappingChanged(line)" (modalEvent)="onModalEvent($event, cellId)" [cssClass]="'form-control form-control-sm mx-wx-384'" [expression]="line.Expression" [hasExternalFormula]="true"
                                                    [readonly]="readonly" name="expression-{{line.Id}}">
                        </mes-web-expression-formula>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container *ngIf="(line.Expression | isExpressionEmpty) && !readonly" [ngTemplateOutletContext]="{columnName: column.Name}" [ngTemplateOutlet]="editIcon"></ng-container>
                        <app-expression-formula-view [expression]="line.Expression" class="min-wx-256 mx-wx-384"></app-expression-formula-view>
                      </ng-template>
                    </p-cellEditor>
                  </ng-container>
                  <ng-container *ngSwitchCase="columnIdentifiers.Constraints">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <mes-web-expression-formula (changed)="onMappingChanged(line)" (modalEvent)="onModalEvent($event, cellId)" [cssClass]="'form-control form-control-sm mx-wx-384'" [expression]="line.Constraints" [hasExternalFormula]="true"
                                                    [readonly]="readonly" name="constraints-{{line.Id}}">
                        </mes-web-expression-formula>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container *ngIf="(line.Constraints | isExpressionEmpty) && !readonly" [ngTemplateOutletContext]="{columnName: column.Name}" [ngTemplateOutlet]="editIcon"></ng-container>
                        <app-expression-formula-view [expression]="line.Constraints" class="min-wx-256 mx-wx-384"></app-expression-formula-view>
                      </ng-template>
                    </p-cellEditor>
                  </ng-container>
                  <ng-container *ngSwitchCase="columnIdentifiers.Mandatory">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <mes-web-expression-formula (changed)="onMappingChanged(line)" (modalEvent)="onModalEvent($event, cellId)" [cssClass]="'form-control form-control-sm mx-wx-384'" [expression]="line.Mandatory" [hasExternalFormula]="false"
                                                    [readonly]="readonly" name="mandatory-expression-{{line.Id}}">
                        </mes-web-expression-formula>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container *ngIf="(line.Mandatory | isExpressionEmpty) && !readonly" [ngTemplateOutletContext]="{columnName: column.Name}" [ngTemplateOutlet]="editIcon"></ng-container>
                        <app-expression-formula-view [expression]="line.Mandatory" class="min-wx-256 mx-wx-384"></app-expression-formula-view>
                      </ng-template>
                    </p-cellEditor>
                  </ng-container>
                  <ng-container *ngSwitchCase="columnIdentifiers.AliasFormula">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <mes-web-expression-formula (changed)="onMappingChanged(line)" (modalEvent)="onModalEvent($event, cellId)" [cssClass]="'form-control form-control-sm mx-wx-384'" [expression]="line.AliasFormula" [hasExternalFormula]="false"
                                                    [readonly]="readonly" name="alias-expression-{{line.Id}}">
                        </mes-web-expression-formula>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container *ngIf="(line.AliasFormula | isExpressionEmpty) && !readonly" [ngTemplateOutletContext]="{columnName: column.Name}" [ngTemplateOutlet]="editIcon"></ng-container>
                        <app-expression-formula-view [expression]="line.AliasFormula" class="min-wx-256 mx-wx-384"></app-expression-formula-view>
                      </ng-template>
                    </p-cellEditor>
                  </ng-container>
                  <ng-container *ngSwitchCase="columnIdentifiers.Alias">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <div class="input-group">
                          <textarea (change)="onMappingChanged(line)" [(ngModel)]="line.Alias" [minRows]="1" [readonly]="readonly" autosize class="form-control form-control-sm" mesStopArrowKeyPropagation name="alias-{{line.Id}}"></textarea>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container *ngIf="!line.Alias && !readonly" [ngTemplateOutletContext]="{columnName: column.Name}" [ngTemplateOutlet]="editIcon"></ng-container>
                        {{ line.Alias }}
                      </ng-template>
                    </p-cellEditor>
                  </ng-container>
                  <ng-container *ngSwitchCase="columnIdentifiers.Sequence">
                    <p-cellEditor class="d-flex">
                      <ng-template pTemplate="input">
                        <div class="input-group">
                          <input (input)="onMappingChanged(line); scrollToSpec(line.Id)" [(ngModel)]="line.Sequence" [readonly]="readonly" class="form-control form-control-sm number-input" mesStopArrowKeyPropagation name="Sequence-{{line.Id}}" type="number">
                        </div>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container *ngIf="!line.Sequence && !readonly" [ngTemplateOutletContext]="{columnName: column.Name}" [ngTemplateOutlet]="editIcon"></ng-container>
                        <span class="ms-auto">{{ line.Sequence }}</span>
                        @if (line.Sequence == null && property?.Sequence != null) {
                          <span class="ms-auto fst-italic text-muted">{{ property?.Sequence }}</span>
                        }
                      </ng-template>
                    </p-cellEditor>
                  </ng-container>
                  <ng-container *ngSwitchCase="columnIdentifiers.Group">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <mes-web-classificator-value-select (entityIdChange)="onClvPropertyChanged(line, $event, 'GroupClv')" [entityId]="line.GroupClv" [initOpened]="true" [items$]="classificatorValuesQuery.propertyGroups$" [readonly]="readonly"
                                                            id="group-{{line.Id}}" name="group-{{line.Id}}">
                        </mes-web-classificator-value-select>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container *ngIf="!line.GroupClv && !readonly" [ngTemplateOutletContext]="{columnName: column.Name}" [ngTemplateOutlet]="editIcon"></ng-container>
                        {{ classificatorValuesQuery.selectEntity(line.GroupClv) | async | displayName }}
                      </ng-template>
                    </p-cellEditor>
                  </ng-container>
                  <ng-container *ngSwitchCase="columnIdentifiers.Priority">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <div class="input-group">
                          <ng-select (change)="onClvPropertyChanged(line, $event?.Id, 'PriorityClv')" [(ngModel)]="line.PriorityClv" [items]="classificatorValuesQuery.specPriorities$ | async | orderBy: 'Sequence'" [readonly]="readonly" [virtualScroll]="true"
                                     appendTo="body" bindLabel="Code" bindValue="Id" class="select-sm form-control" id="priority-{{line.Id}}" name="priority-{{line.Id}}">
                            <ng-template let-item="item" ng-label-tmp>
                        <span class="{{item.Value}}">
                          {{ item.Code }}
                        </span>
                            </ng-template>
                          </ng-select>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container *ngIf="!line.PriorityClv && !readonly" [ngTemplateOutletContext]="{columnName: column.Name}" [ngTemplateOutlet]="editIcon"></ng-container>
                        <span *ngIf="classificatorValuesQuery.selectEntity(line.PriorityClv) | async as priority" class="{{priority.Value}}">
                      {{ priority.Code }}
                    </span>
                      </ng-template>
                    </p-cellEditor>
                  </ng-container>
                  <ng-container *ngSwitchCase="columnIdentifiers.MessageFormula">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <mes-web-expression-formula (changed)="onMappingChanged(line)" (modalEvent)="onModalEvent($event, cellId)" [cssClass]="'form-control form-control-sm mx-wx-384'" [expression]="line.MessageFormula" [hasExternalFormula]="false"
                                                    [readonly]="readonly" name="message-expression-{{line.Id}}">
                        </mes-web-expression-formula>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container *ngIf="(line.MessageFormula | isExpressionEmpty) && !readonly" [ngTemplateOutletContext]="{columnName: column.Name}" [ngTemplateOutlet]="editIcon"></ng-container>
                        <app-expression-formula-view [expression]="line.MessageFormula" class="min-wx-256 mx-wx-384"></app-expression-formula-view>
                      </ng-template>
                    </p-cellEditor>
                  </ng-container>
                  <ng-container *ngSwitchCase="columnIdentifiers.Message">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <div class="input-group">
                          <textarea (change)="onMappingChanged(line)" [(ngModel)]="line.Message" [minRows]="1" [readonly]="readonly" autosize class="form-control form-control-sm" mesStopArrowKeyPropagation name="message-{{line.Id}}"></textarea>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <ng-container *ngIf="!line.Message && !readonly" [ngTemplateOutletContext]="{columnName: column.Name}" [ngTemplateOutlet]="editIcon"></ng-container>
                        {{ line.Message }}
                      </ng-template>
                    </p-cellEditor>
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>
            <td class="text-end" style="white-space: nowrap" pFrozenColumn alignFrozen="right">
              <button (click)="setShowLocalizationByLine(line)" *ngIf="!line.LanguageId && showLocalizationButton"
                      [className]="(line | isSpecWithLocalizations: context.Specs) ? 'btn btn-sm me-1 btn-outline-primary' : 'btn btn-sm me-1 btn-outline-default text-gray-200 border-0'" [ngClass]="{'active': line.ShowLocalization}" type="button">
                <svg class="icon small" inlineSVG="#flag" viewBox="0 0 8 8"></svg>
              </button>
              <div class="btn-group me-1" ngbDropdown>
                <button (click)="remove(line)" *ngIf="!readonly" class="btn btn-danger btn-sm" type="button">
                  <svg class="icon small" inlineSVG="#trash" viewBox="0 0 8 8"></svg>
                </button>
                <ng-container *ngIf="hasSourceColumn">
                  <button class="btn btn-danger dropdown-toggle-split" ngbDropdownToggle></button>
                  <div class="dropdown-menu" ngbDropdownMenu>
                    <button (click)="line.resetValue(); line.resetLineSource()" ngbDropdownItem type="button">
                      <svg class="icon small" inlineSVG="#trash" viewBox="0 0 8 8"></svg>
                      {{ t('Value') }}
                    </button>
                    <button (click)="line.resetMapping(); line.resetMappingSource()" ngbDropdownItem type="button">
                      <svg class="icon small" inlineSVG="#trash" viewBox="0 0 8 8"></svg>
                      {{ t('Mapping') }}
                    </button>
                  </div>
                </ng-container>
              </div>
            </td>
          </tr>
        </ng-container>
      </ng-template>
      <ng-template #editIcon let-columnName="columnName">
        <span class="show-on-parent-hover text-gray-400 text-nowrap">
          {{ columnName | transloco }}
          <svg class="icon small" inlineSVG="#pencil" viewBox="0 0 8 8"></svg>
        </span>
      </ng-template>
    </p-table>
    <div *ngIf="!readonly" class="col text-end">
      <button (click)="addNewSpecLine()" class="btn btn-sm btn-outline-primary mt-1" id="addNew" type="button">
        <svg class="icon small" inlineSVG="#plus" viewBox="0 0 8 8"></svg>
        {{ t('Add') }}
      </button>
    </div>
  </ng-container>
</ng-container>
